import { useTranslation } from "react-i18next";
//import i18n from "../../../locales/i18n";
import StepBox from "./StepBox";

export default function Steps(){
  const {t} = useTranslation();
  //const locale = i18n.language ?? 'ko';
  const data = [];
  for(let i = 1; i < 13; i++){
    data.push({
      title: t(`business.steps.title-${i}`),
      comment: t(`business.steps.comment-${i}`),
      img: require(`assets/images/solutions/business/icon_${i}.png`)
    });
  }

  const rows=[0, 1, 2, 3];
  const cols = [0, 1, 2];

  return (
    <div className="flex justify-center w-full py-10 my-10 bg-gray-50">
      <div className="flex flex-col lg:max-w-[1200px]">
        {rows.map((row)=>{
          return (
            <div key={row} className="flex flex-col lg:px-4 lg:flex-row">
              {cols.map(col=>{
                const index = 3*row + col;
                return (<StepBox key={index} className="w-full lg:w-[400px]" 
                  title={data[index].title} subTitle={data[index].subTitle} 
                  comment={data[index].comment} img={data[index].img}/>);
              })}
            </div>
          );
        })}
      </div>
    </div>
  );
}